import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { SurveyResponseList } from './list';
import { SurveyResponseFilter } from './filters/props';
import { SurveyResponseFilters } from './filters';

export const SurveyResponses = () => {
    const [filters, setFilters] = useState<SurveyResponseFilter>();

    return (
        <>
            <LayoutModule title="Respuestas de Encuestas" showTitle>
                <SurveyResponseFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <SurveyResponseList filters={filters} />
        </>
    );
};
